import { IPresentationModel, PresentationModel } from './presentation-model';

export interface IGetPresentationForEditingResponse {
    existingTitles: string[];
    model: IPresentationModel;
}


export class GetPresentationForEditingResponse implements IGetPresentationForEditingResponse {
    public existingTitles: string[] = [];
    public model: IPresentationModel = new PresentationModel();
}


